/* ═══════════════════════════════════════════════════════
   PALLINE DI NATALE — CONFIGURATORE (Shopify)
   La config (modelli, colori, varianti, immagini, sfondo, sconti)
   arriva da window.PALLINE_CFG, iniettata dallo snippet Liquid.
═══════════════════════════════════════════════════════ */
(function(){
'use strict';

const CFG = window.PALLINE_CFG || {};
const CW = 760, CH = 760;

const COLORS   = CFG.colors   || [];
const BALLS    = CFG.models   || [];
const DISCOUNT = CFG.discount || [];   // es. [{q:3,pct:10},{q:4,pct:15},{q:5,pct:20}]

/* ═══════════ STATE ═══════════ */
const state = {
  ballId: BALLS.length ? BALLS[0].id : null,
  name:   '',
  name2:  '',
  color:  COLORS[0] || { name:'Oro', hex:'#C9A227' },
};

const root   = document.getElementById('preview-palline-root');
if (!root || !BALLS.length) return;
const canvas = document.getElementById('ppCanvas');
const ctx    = canvas.getContext('2d');

const frameCache = {};   // id → {img, loaded}
const fontLoaded = {};   // family → bool

function currentBall(){ return BALLS.find(b => b.id === state.ballId); }

/* Nome: prima lettera maiuscola, resto minuscolo */
function formatName(s){
  s = (s || '').trim();
  if (!s) return '';
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

/* ═══════════ HELPER TESTO ═══════════ */
const _mc = document.createElement('canvas').getContext('2d');
function fitFontSize(text, targetPx, family, maxPx){
  let lo=4, hi=maxPx, best=lo;
  for (let i=0;i<22;i++){
    const mid=(lo+hi)/2;
    _mc.font = `${mid}px "${family}"`;
    (_mc.measureText(text).width > targetPx) ? (hi=mid) : (best=mid, lo=mid);
  }
  return best;
}
function centerX(text, fontSize, family){
  _mc.font = `${fontSize}px "${family}"`;
  const m=_mc.measureText(text);
  const l=m.actualBoundingBoxLeft ?? 0;
  const r=m.actualBoundingBoxRight ?? m.width;
  return -((r + (-l))/2) + l;
}

/* ═══════════ CARICAMENTO ASSET ═══════════ */
function ensureFont(font){
  if (!font || fontLoaded[font.family] !== undefined) return Promise.resolve();
  return new FontFace(font.family, `url(${font.url})`).load()
    .then(ff => { document.fonts.add(ff); fontLoaded[font.family] = true; })
    .catch(() => { fontLoaded[font.family] = false; });
}
function ensureFrame(ball){
  if (frameCache[ball.id]) return frameCache[ball.id];
  const entry = { img:null, loaded:false };
  frameCache[ball.id] = entry;
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload  = () => { entry.img=img; entry.loaded=true; render(); renderModelThumbs(); };
  img.onerror = () => { entry.loaded=false; render(); };
  img.src = ball.frame;
  return entry;
}

/* ═══════════ SFONDO STAGE ═══════════ */
const STAGE_BG = { img:null, tried:false };
function ensureStageBg(){
  if (STAGE_BG.tried || !CFG.sfondo) return;
  STAGE_BG.tried = true;
  const im = new Image(); im.crossOrigin='anonymous';
  im.onload = () => { STAGE_BG.img=im; render(); };
  im.src = CFG.sfondo;
}
function drawStage(c){
  if (STAGE_BG.img){
    const im=STAGE_BG.img; let sw=im.naturalWidth, sh=im.naturalHeight;
    const ir=sw/sh; if (ir>1) sw=sh; else sh=sw;
    const sx=(im.naturalWidth-sw)/2, sy=(im.naturalHeight-sh)/2;
    c.drawImage(im, sx, sy, sw, sh, 0, 0, CW, CH);
  } else { c.fillStyle='#ffffff'; c.fillRect(0,0,CW,CH); }
}

/* ═══════════ GLITTER ═══════════ */
const GLITTER = true, GLITTER_ALPHA = 0.55;
let glitterTex = null;
function makeGlitterTexture(){
  const g=document.createElement('canvas'); g.width=CW; g.height=CH;
  const gx=g.getContext('2d');
  const id=gx.createImageData(CW,CH), d=id.data;
  for (let i=0;i<d.length;i+=4){ const v=128+(Math.random()*2-1)*20; d[i]=d[i+1]=d[i+2]=v; d[i+3]=255; }
  gx.putImageData(id,0,0);
  for (let n=0;n<2800;n++){ const x=Math.random()*CW,y=Math.random()*CH,r=Math.random()*1.6+0.4,b=(205+Math.random()*50)|0;
    gx.fillStyle=`rgba(${b},${b},${b},${0.5+Math.random()*0.5})`; gx.beginPath(); gx.arc(x,y,r,0,7); gx.fill(); }
  for (let n=0;n<1500;n++){ const x=Math.random()*CW,y=Math.random()*CH,r=Math.random()*1.4+0.3,b=(70+Math.random()*30)|0;
    gx.fillStyle=`rgba(${b},${b},${b},${0.4+Math.random()*0.4})`; gx.beginPath(); gx.arc(x,y,r,0,7); gx.fill(); }
  return g;
}
function buildMaterial(mask, color){
  const mat=document.createElement('canvas'); mat.width=CW; mat.height=CH;
  const m=mat.getContext('2d');
  m.drawImage(mask,0,0);
  m.globalCompositeOperation='source-in'; m.fillStyle=color; m.fillRect(0,0,CW,CH);
  m.globalCompositeOperation='source-over';
  if (GLITTER && glitterTex){
    const gl=document.createElement('canvas'); gl.width=CW; gl.height=CH;
    const glc=gl.getContext('2d');
    glc.drawImage(glitterTex,0,0);
    glc.globalCompositeOperation='destination-in'; glc.drawImage(mask,0,0);
    m.globalCompositeOperation='overlay'; m.globalAlpha=GLITTER_ALPHA;
    m.drawImage(gl,0,0); m.globalAlpha=1; m.globalCompositeOperation='source-over';
  }
  return mat;
}

/* ═══════════ NOME (maschera) ═══════════ */
function drawNameMask(octx, text, pos, family, knockout){
  if (!text) return;
  const fitted=Math.min(pos.size, fitFontSize(text, CW*(pos.maxW/100), family, 360));
  const cx=CW*(pos.cx/100), cy=CH*(pos.cy/100);
  const drawX=centerX(text, fitted, family);
  octx.save();
  octx.translate(cx,cy);
  if (pos.rot) octx.rotate(pos.rot*Math.PI/180);
  octx.textAlign='left'; octx.textBaseline='middle';
  octx.font=`${fitted}px "${family}"`;
  octx.globalCompositeOperation = knockout ? 'destination-out' : 'source-over';
  octx.fillStyle='#000';
  octx.fillText(text, drawX, 0);
  octx.restore();
}

/* ═══════════ 3D ═══════════ */
const THREED=true, DEPTH_3D=6, DEPTH_DX=0.5, DEPTH_DY=1;
const SHADOW_DX=7, SHADOW_DY=14, SHADOW_BLUR=8, SHADOW_ALPHA=0.45;
const HOLE_SHOW_BG=true;   // fori nome inciso trasparenti (traforo)
function darkenHex(hex, amt){
  hex=hex.replace('#',''); if (hex.length===3) hex=hex.split('').map(c=>c+c).join('');
  let r=parseInt(hex.slice(0,2),16),g=parseInt(hex.slice(2,4),16),b=parseInt(hex.slice(4,6),16);
  r=Math.round(r*(1-amt)); g=Math.round(g*(1-amt)); b=Math.round(b*(1-amt));
  return `rgb(${r},${g},${b})`;
}
function silhouette(maskCanvas, color){
  const c=document.createElement('canvas'); c.width=CW; c.height=CH;
  const x=c.getContext('2d');
  x.drawImage(maskCanvas,0,0); x.globalCompositeOperation='source-in';
  x.fillStyle=color; x.fillRect(0,0,CW,CH);
  return c;
}

/* ═══════════ RENDER ═══════════ */
function render(){
  const ball=currentBall(); if(!ball) return;
  const color=state.color.hex;

  ctx.clearRect(0,0,CW,CH);
  drawStage(ctx);

  const frame=ensureFrame(ball);

  if (!HOLE_SHOW_BG && frame.loaded && frame.img){
    const back=document.createElement('canvas'); back.width=CW; back.height=CH;
    const bk=back.getContext('2d');
    bk.drawImage(frame.img,0,0,CW,CH);
    bk.globalCompositeOperation='source-in'; bk.fillStyle='#ffffff'; bk.fillRect(0,0,CW,CH);
    ctx.drawImage(back,0,0);
  }

  const mask=document.createElement('canvas'); mask.width=CW; mask.height=CH;
  const mk=mask.getContext('2d');
  if (frame.loaded && frame.img) mk.drawImage(frame.img,0,0,CW,CH);

  const family = fontLoaded[ball.font.family] ? ball.font.family : 'Georgia';
  if (ball.mode==='twoname'){
    drawNameMask(mk, formatName(state.name),  ball.namePos[0], family, false);
    drawNameMask(mk, formatName(state.name2), ball.namePos[1], family, false);
  } else {
    drawNameMask(mk, formatName(state.name), ball.namePos, family, !!ball.engraveKnockout);
  }

  const material=buildMaterial(mask, color);

  if (THREED){
    ctx.save();
    ctx.globalAlpha=SHADOW_ALPHA;
    if ('filter' in ctx) ctx.filter=`blur(${SHADOW_BLUR}px)`;
    ctx.drawImage(silhouette(mask,'#000'), SHADOW_DX, SHADOW_DY);
    ctx.filter='none'; ctx.globalAlpha=1; ctx.restore();
    const side=silhouette(mask, darkenHex(color,0.5));
    for (let k=DEPTH_3D;k>=1;k--) ctx.drawImage(side, DEPTH_DX*k, DEPTH_DY*k);
  }
  ctx.drawImage(material,0,0);
}

/* ═══════════ VARIANTI / CARRELLO ═══════════ */
// Trova l'ID variante per (modello, colore). Classica → richiede sfondo 'No'.
function findVariantId(ball, colorName){
  const vs = ball.variants || [];
  for (const v of vs){
    const opt = v.options || [];
    if (ball.noBackground){
      if (opt[0]===colorName && opt[1]==='No') return v.id;
    } else {
      if (opt[0]===colorName) return v.id;
    }
  }
  return null;
}
// Colori disponibili per il modello corrente (solo quelli con una variante valida)
function colorsForBall(ball){
  return COLORS.filter(c => findVariantId(ball, c.name) != null);
}

/* ═══════════ UI: THUMBNAIL MODELLI ═══════════ */
const modelsGrid = document.getElementById('ppModels');
function thumbTint(hex){
  const h=hex.replace('#',''); const r=parseInt(h.slice(0,2),16),g=parseInt(h.slice(2,4),16),b=parseInt(h.slice(4,6),16);
  const lum=(0.299*r+0.587*g+0.114*b)/255;
  return lum>0.90 ? '#CFCCC5' : hex;
}
function renderModelThumbs(){
  modelsGrid.innerHTML='';
  const tint = thumbTint(state.color.hex);
  BALLS.forEach(b => {
    const btn=document.createElement('button');
    btn.type='button';
    btn.className='pp-model'+(b.id===state.ballId?' active':'');
    const c=document.createElement('canvas'); c.width=120; c.height=120;
    const cx=c.getContext('2d'); cx.fillStyle='#fff'; cx.fillRect(0,0,120,120);
    const fr=frameCache[b.id];
    if (fr && fr.loaded && fr.img){
      const tmp=document.createElement('canvas'); tmp.width=120; tmp.height=120; const t=tmp.getContext('2d');
      t.drawImage(fr.img,0,0,120,120);
      t.globalCompositeOperation='source-in'; t.fillStyle=tint; t.fillRect(0,0,120,120);
      cx.drawImage(tmp,0,0);
    } else { if(!fr) ensureFrame(b); }
    const span=document.createElement('span'); span.textContent=b.label;
    btn.append(c,span);
    btn.onclick=()=>selectBall(b.id);
    modelsGrid.append(btn);
  });
}

async function selectBall(id){
  state.ballId=id;
  const ball=currentBall();
  await ensureFont(ball.font);
  ensureColorValid();
  buildNameFields();
  buildColors();
  renderModelThumbs();
  buildGallery();
  updatePrice();
  render();
}

/* ═══════════ UI: NOME ═══════════ */
function buildNameFields(){
  const wrap=document.getElementById('ppNameFields');
  const ball=currentBall();
  document.getElementById('ppNameLabel').textContent =
    ball.mode==='twoname' ? 'Scrivi i due nomi' : 'Scrivi il nome';
  wrap.innerHTML='';
  const mk=(val,ph,hint,on)=>{
    const g=document.createElement('div'); g.className='pp-field';
    const i=document.createElement('input'); i.className='pp-input'; i.type='text';
    i.value=val; i.placeholder=ph; i.maxLength=20; i.autocomplete='off'; i.spellcheck=false;
    const h=document.createElement('span'); h.className='pp-hint'; h.textContent=hint;
    i.addEventListener('input',()=>{ on(i.value); render(); });
    g.append(i,h); return g;
  };
  if (ball.mode==='twoname'){
    wrap.append(
      mk(state.name,  'Primo nome',  'Nome in alto',  v=>state.name=v),
      mk(state.name2, 'Secondo nome','Nome in basso', v=>state.name2=v)
    );
  } else {
    wrap.append( mk(state.name, 'Es. Edoardo', 'Nome (anche nome + cognome)', v=>state.name=v) );
  }
}

/* ═══════════ UI: COLORI ═══════════ */
function ensureColorValid(){
  const ball=currentBall();
  const avail=colorsForBall(ball);
  if (!avail.some(c=>c.name===state.color.name)) state.color = avail[0] || state.color;
}
function buildColors(){
  const wrap=document.getElementById('ppColors');
  const ball=currentBall();
  wrap.innerHTML='';
  colorsForBall(ball).forEach(col=>{
    const s=document.createElement('button');
    s.type='button';
    s.className='pp-swatch'+(col.name===state.color.name?' active':'');
    s.style.background=col.hex; s.title=col.name;
    if (col.hex.toUpperCase()==='#FFFFFF') s.style.boxShadow='inset 0 0 0 1px #ddd';
    s.onclick=()=>{
      state.color=col;
      document.getElementById('ppColorLabel').textContent=col.name;
      [...wrap.children].forEach(c=>c.classList.remove('active'));
      s.classList.add('active');
      render(); renderModelThumbs();
    };
    wrap.append(s);
  });
  document.getElementById('ppColorLabel').textContent=state.color.name;
}

/* ═══════════ UI: GALLERY (immagini reali del prodotto) ═══════════ */
let galleryImages = [];
function buildGallery(){
  const box=document.getElementById('ppGallery');
  const grid=document.getElementById('ppGalleryGrid');
  const ball=currentBall();
  grid.innerHTML='';
  galleryImages = (ball.images||[]).slice(0,12).map(item => {
    if (typeof item === 'string') return { thumb:item, full:item };
    return { thumb:item.thumb || item.full || '', full:item.full || item.thumb || '' };
  }).filter(item => item.thumb && item.full);
  if (!galleryImages.length){ box.style.display='none'; return; }
  box.style.display='flex';
  galleryImages.forEach((item, i)=>{
    const im=document.createElement('img'); im.loading='lazy'; im.src=item.thumb;
    im.alt='Foto '+ball.label;
    im.onerror=()=>im.remove();
    im.onclick=()=>openLightbox(i);   // click miniatura → immagine grande
    grid.append(im);
  });
}

/* ═══════════ LIGHTBOX (zoom foto, con scorrimento) ═══════════ */
let lbIndex=0;
function openLightbox(i){
  if (!galleryImages.length) return;
  lbIndex=i;
  const lb=document.getElementById('ppLightbox');
  document.getElementById('ppLbImg').src=galleryImages[lbIndex].full;
  lb.classList.add('open'); lb.setAttribute('aria-hidden','false');
  const multi=galleryImages.length>1;
  document.getElementById('ppLbPrev').style.display=multi?'flex':'none';
  document.getElementById('ppLbNext').style.display=multi?'flex':'none';
}
function closeLightbox(){
  const lb=document.getElementById('ppLightbox');
  lb.classList.remove('open'); lb.setAttribute('aria-hidden','true');
}
function lbStep(d){
  if (!galleryImages.length) return;
  lbIndex=(lbIndex+d+galleryImages.length)%galleryImages.length;
  document.getElementById('ppLbImg').src=galleryImages[lbIndex].full;
}

/* ═══════════ PREZZO ═══════════ */
function updatePrice(){
  const ball=currentBall();
  const el=document.getElementById('ppPrice');
  if (el) el.textContent = ball.priceLabel || '';
  const cta=document.getElementById('ppTotal');
  if (cta) cta.textContent = ball.priceLabel || '';
}

/* ═══════════ TRACKER PROMO (bundle) ═══════════ */
async function refreshBundle(){
  const el=document.getElementById('ppBundle');
  if (!el || !DISCOUNT.length) return;
  let count=0;
  try{
    const cart=await (await fetch('/cart.js')).json();
    const handles=new Set(BALLS.map(b=>b.handle));
    cart.items.forEach(it=>{ if (handles.has(it.handle)) count += it.quantity; });
  }catch(e){}
  const tiers=[...DISCOUNT].sort((a,b)=>a.q-b.q);
  let current=null, next=null;
  for (const t of tiers){ if (count>=t.q) current=t; else { next=t; break; } }
  let lines='';
  if (current) lines += `<span class="pp-bundle-on">Sconto ${current.pct}% attivo su ${count} palline</span>`;
  if (next){
    const missing=next.q-count;
    lines += `<span class="pp-bundle-next">Aggiungi ${missing} pallin${missing===1?'a':'e'} e ottieni <strong>${next.pct}% di sconto</strong></span>`;
    const max=tiers[tiers.length-1].q;
    const pct=Math.min(100, Math.round(count/max*100));
    lines += `<span class="pp-bundle-bar"><span style="width:${pct}%"></span></span>`;
  } else if (current){
    lines += `<span class="pp-bundle-next">Sconto massimo raggiunto.</span>`;
  }
  const html = `
    <div class="pp-bundle-card">
      <span class="pp-bundle-ico" aria-hidden="true">%</span>
      <span class="pp-bundle-copy">
        <span class="pp-bundle-title">Sconto famiglia</span>
        ${lines}
      </span>
    </div>`;
  el.innerHTML=html;
}

/* ═══════════ ADD TO CART ═══════════ */
function collectProps(ball){
  const props={ 'Modello': ball.label };
  if (ball.mode==='twoname'){
    props['Nome 1']=formatName(state.name);
    props['Nome 2']=formatName(state.name2);
  } else {
    props['Nome']=formatName(state.name);
  }
  return props;
}
function validNames(ball){
  if (ball.mode==='twoname') return formatName(state.name) && formatName(state.name2);
  return !!formatName(state.name);
}
// Miniatura JPEG dell'anteprima (data URL) da allegare all'articolo del carrello.
// Il prefisso "_" nella proprietà la nasconde dall'elenco ma resta leggibile dal tema.
function generatePreviewThumb(){
  try{
    const t=document.createElement('canvas'); t.width=300; t.height=300;
    t.getContext('2d').drawImage(canvas, 0, 0, 300, 300);
    return t.toDataURL('image/jpeg', 0.72);
  }catch(e){ return null; }   // canvas "tainted" o non disponibile → niente miniatura
}

async function addToCart(){
  const ball=currentBall();
  if (!validNames(ball)){ showToast('⚠️ Inserisci il nome prima di continuare'); return; }
  const variantId=findVariantId(ball, state.color.name);
  if (!variantId){ showToast('⚠️ Colore non disponibile per questo modello'); return; }

  const btn=document.getElementById('ppAdd');
  const orig=btn.textContent; btn.disabled=true; btn.textContent='Aggiunta in corso…';

  render();                                  // assicura il canvas aggiornato
  const props=collectProps(ball);
  const thumb=generatePreviewThumb();
  if (thumb) props['_preview']=thumb;        // miniatura mostrata nel carrello

  try{
    const res=await fetch('/cart/add.js',{
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ items:[{ id:variantId, quantity:1, properties:props }] })
    });
    if (!res.ok){ const e=await res.json(); throw new Error(e.description||'Errore'); }
    afterAdd();
  }catch(err){
    showToast('⚠️ '+err.message);
  }finally{
    btn.disabled=false; btn.textContent=orig;
  }
}

/* Dopo l'aggiunta: invito ad aggiungere un altro nome + aggiorna tracker */
function afterAdd(){
  refreshBundle();
  const panel=document.getElementById('ppAdded');
  if (panel) panel.classList.add('show');
  showToast('✅ Aggiunta al carrello!');
}
function resetForAnother(){
  state.name=''; state.name2='';
  buildNameFields();
  render();
  const panel=document.getElementById('ppAdded'); if (panel) panel.classList.remove('show');
  root.scrollIntoView({behavior:'smooth', block:'start'});
}

/* Toast */
let toastTimer=null;
function showToast(msg){
  let t=document.getElementById('ppToast');
  if (!t){ t=document.createElement('div'); t.id='ppToast'; document.body.appendChild(t); }
  t.textContent=msg; t.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer=setTimeout(()=>t.classList.remove('show'), 2600);
}

/* ═══════════ INIT ═══════════ */
async function init(){
  glitterTex=makeGlitterTexture();
  ensureStageBg();
  ensureColorValid();
  renderModelThumbs();
  await ensureFont(currentBall().font);
  buildNameFields();
  buildColors();
  buildGallery();
  updatePrice();
  render();
  refreshBundle();

  document.getElementById('ppAdd').onclick=addToCart;
  const another=document.getElementById('ppAnother');
  if (another) another.onclick=resetForAnother;
  const goCart=document.getElementById('ppGoCart');
  if (goCart) goCart.onclick=()=>{ window.location.href='/cart'; };

  // Lightbox: chiusura, navigazione, tastiera, click sfondo
  const lb=document.getElementById('ppLightbox');
  const lbClose=document.getElementById('ppLbClose');
  if (lbClose) lbClose.onclick=closeLightbox;
  const lbPrev=document.getElementById('ppLbPrev'), lbNext=document.getElementById('ppLbNext');
  if (lbPrev) lbPrev.onclick=(e)=>{ e.stopPropagation(); lbStep(-1); };
  if (lbNext) lbNext.onclick=(e)=>{ e.stopPropagation(); lbStep(1); };
  if (lb) lb.addEventListener('click', (e)=>{ if (e.target===lb) closeLightbox(); });
  document.addEventListener('keydown', (e)=>{
    if (!lb || !lb.classList.contains('open')) return;
    if (e.key==='Escape') closeLightbox();
    else if (e.key==='ArrowLeft') lbStep(-1);
    else if (e.key==='ArrowRight') lbStep(1);
  });

  const loading=document.getElementById('ppLoading');
  if (loading) loading.classList.add('hidden');
}

if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', init);
else init();

})();
